import gql from 'graphql-tag';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import CLASSROOM_USER_ENROLLMENT_FRAGMENT from 'graph/fragments/classroom-user-enrollment';

const UPDATE_CLASSROOM_MUTATION = gql`
  mutation updateClassroomMutation($classroomId: Int, $data: ClassroomUpdateInput!) {
    updateClassroom(data: $data, where: { id: $classroomId }) {
      ...BaseClassroom
      users {
        ...BaseClassroomUserEnrollment
      }
      organization {
        id
        name
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${CLASSROOM_USER_ENROLLMENT_FRAGMENT}
`;

export default UPDATE_CLASSROOM_MUTATION;
